import { render, staticRenderFns } from "./Verwendungszweck.vue?vue&type=template&id=47d6ef33&"
import script from "./Verwendungszweck.vue?vue&type=script&lang=js&"
export * from "./Verwendungszweck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports